import fetchHTTP from 'Utils/fetchHTTP';

const signInAuth0 = accessToken => fetchHTTP('/v1/public/universal_auth/log_in', {
  headers: { 'Universal-Auth-Token': accessToken },
  method: 'POST',
});

const logOut = () => fetchHTTP('/v1/public/auth/log_out', {
  headers: { Authorization: localStorage.kueski_session },
  method: 'POST',
});

const SignUpService = credentials => fetchHTTP('/v1/public/auth/sign_up', {
  data: credentials,
  method: 'POST',
});

export {
  logOut,
  signInAuth0,
  SignUpService,
};
